function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0zm203.491-104.377l4.421 13.605h14.305l-11.574 8.408 4.421 13.604-11.573-8.408-11.572 8.408 4.421-13.604-11.574-8.408h14.305zm0 59.361l4.421 13.606h14.305l-11.574 8.406 4.421 13.605-11.573-8.408-11.572 8.408 4.421-13.605-11.574-8.406h14.305zm105.018-59.361l4.42 13.605h14.305l-11.574 8.408 4.421 13.604-11.572-8.408-11.573 8.408 4.421-13.604-11.574-8.408h14.305zm0 59.361l4.42 13.606h14.305l-11.574 8.406 4.421 13.605-11.572-8.408-11.573 8.408 4.421-13.605-11.574-8.406h14.305zM256 238.191l4.421 13.605h14.304l-11.573 8.408 4.421 13.605L256 265.401l-11.573 8.408 4.421-13.605-11.573-8.408h14.304z",
  fill: "#338af3"
});

const SvgHonduras = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHonduras, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/honduras.ef5cc52d.svg";
export { ForwardRef as ReactComponent };